import axiosInstance from "../Shared/Utils/axiosInstance";

export const loginFromServer = async (loginId, password) => {
  // const response = await axios.post('http://cockpit-alb-399440815.ap-south-1.elb.amazonaws.com/api/signin', {
  const response = await axiosInstance.post(
    "/api/signin",
    {
      username: loginId,
      password: password,
    },
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  return response.data.data; // Assuming data is encrypted
};
